import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { COMMON_API } from '../../commonAPI';

const EditLoanBenefits = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = sessionStorage.getItem('authToken');

  const [loans, setLoans] = useState([]);
  const [selectedLoanId, setSelectedLoanId] = useState('');
  const [benefitsText, setBenefitsText] = useState('');

  // Fetch all loans
  const fetchLoans = async () => {
    try {
      const res = await axios.get(`${COMMON_API}/loan/allLoans`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLoans(res.data.loan || []);
    } catch (error) {
      console.error('Error fetching loans:', error);
      if (error.response?.status === 401 || error.response?.status === 403) {
        sessionStorage.clear();
        navigate('/');
      }
    }
  };

  // Fetch benefit details
  const fetchBenefitsDetails = async () => {
    try {
      const res = await axios.get(`${COMMON_API}/loan/getSingleLoanBenefits/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const benefits = res.data.benefits;
      setSelectedLoanId(benefits.loan_id);
      setBenefitsText(benefits.benefits);
    } catch (error) {
      console.error('Error fetching benefits details:', error);
      if (error.response?.status === 401 || error.response?.status === 403) {
        sessionStorage.clear();
        navigate('/');
      }
    }
  };

  // Submit update
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedLoanId || !benefitsText.trim()) {
      alert('Loan and benefits are required');
      return;
    }

    try {
      await axios.put(
        `${COMMON_API}/loan/editLoanBenefits/${id}`,
        { loan_id: selectedLoanId, benefits: benefitsText },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      navigate(-1); // go back after update
    } catch (error) {
      console.error('Error updating benefits:', error);
      if (error.response?.status === 401 || error.response?.status === 403) {
        sessionStorage.clear();
        navigate('/');
      }
    }
  };

  useEffect(() => {
    fetchLoans();
    fetchBenefitsDetails();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-6">
      <div className="w-full max-w-lg bg-white rounded-2xl shadow-lg p-8">
        <h2 className="text-2xl font-bold mb-6 text-gray-800">Edit Loan Benefit</h2>

        <form onSubmit={handleSubmit} className="space-y-5">
          {/* Loan Selection */}
          <div>
            <label className="block text-gray-600 font-medium mb-1">Select Loan</label>
            <select
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
              value={selectedLoanId}
              onChange={(e) => setSelectedLoanId(e.target.value)}
              required
            >
              <option value="">-- Select Loan --</option>
              {loans.map((loan, index) => (
                <option key={`${loan.id}-${index}`} value={loan.id}>
                  {loan.name}
                </option>
              ))}
            </select>
          </div>

          {/* Benefit Description */}
          <div>
            <label className="block text-gray-600 font-medium mb-1">Benefit Description</label>
            <textarea
              rows="4"
              value={benefitsText}
              onChange={(e) => setBenefitsText(e.target.value)}
              placeholder="Edit benefit description..."
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          {/* Submit */}
          <button
            type="submit"
            className="w-full bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition"
          >
            Update Benefit
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditLoanBenefits;
